import DibbleConfigs from "./dibble-config";

const DibbleAPI = {
    endpoint: DibbleConfigs.apiEndpoint,
    downloadUri: DibbleConfigs.downloadInvoiceUri,
    api: {
        getWelcomePageData: 'Campaign/get_welcome_data',
        getDonatePageData: 'Campaign/get_donate_data',
        getDonationData: 'Campaign/get_donation_data',
        getDonationRequestData: 'Campaign/get_donation_request_data',
        getThankYouPageData: 'Campaign/get_thankyou_data',
        donate: 'Donation/save',
        getWallData: 'Campaign/get_wall_data',
        getWallAmountData: 'Campaign/get_wall_amount_data',
        donationWithTilled: 'Donation/donate_event_with_tilled',
        tilledGetPaymentStatus: 'Donation/get_tilled_payment_status',
        getCountryCodes: 'General/get_country_phone_codes',
        getStateList: 'General/get_states',
    },
    isResponseSuccess(responseData) {
        return parseInt(responseData.rc) === 0;
    }
}

export default DibbleAPI;
